import { createContext, useContext } from "react";
export const AppCtx = createContext({ me: null, users: [], settings: {}, refresh: () => {} });
export const useApp = () => useContext(AppCtx);
